import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import RandomStringGenerator from "../../Functions/GenerateRandomCode";

const ActionFileModal = ({ project_id, show, handleClose, selectedFiles, fetchCloud, actionModal, setSelectedFiles }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)
    const [mexDelete, setMexDelete] = useState("Move to deleted")
    const [mexDeletePermanently, setMexDeletePermanently] = useState("Delete permanently")
    const [mexActivate, setMexActivate] = useState("Restore file")

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === mexDelete || value === mexActivate || value === mexDeletePermanently) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        handleClose()
        setTimeout(() => {
            setInputValue("")
        }, 100);
    }

    const actionOrganization = async () => {
        try {
            setLoadingDel(true)
            const response = await fetch("https://backend.erioon.com/action_cloud_file", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id: user_id, project_id: project_id, file_ids: selectedFiles, action: actionModal }),
            });
            setLoadingDel(false)
            const errorData = await response.json();
            if (response.ok) {
                fetchCloud()
                setInputValue("")
                setSelectedFiles([])
            } else {
                const errorData = await response.json();
            }
        } catch (err) {
            setLoadingDel(false)
        } finally {
            setLoadingDel(false)
            handleCloseModal();
        }


    };

    let modalContent
    if (actionModal === "activate") {
        modalContent = (
            <Modal show={show} onHide={handleCloseModal} className="modal_delete">
                <div className="modal_header">
                    <p>{t.cloud.restore_file}</p>
                    <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
                </div>
                <div className="modal_body">
                    <p className="warning_delete_message">
                        {t.cloud.restore_warning}
                    </p>
                    <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{mexActivate}</strong></p>
                        <input
                            className="delete_input"
                            placeholder={` ${mexActivate}`}
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="modal_footer">
                    <div className="footer_btn_cont">
                        <button
                            className={`activate_btn ${isButtonDisabled ? "" : "activate_btn_active"}`}
                            onClick={actionOrganization}
                            disabled={isButtonDisabled}
                        >
                            {loadingDel ? (
                                <Spinner loading={loadingDel} />
                            ) : (
                                <>{t.save}</>
                            )}
                        </button>

                        <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                    </div>
                </div>
            </Modal>
        )
    } else if (actionModal === "delete_permanently") {
        modalContent = (
            <Modal show={show} onHide={handleCloseModal} className="modal_delete">
                <div className="modal_header">
                    <p>{t.cloud.delete_file}</p>
                    <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
                </div>
                <div className="modal_body">
                    <p className="warning_delete_message">
                        {t.cloud.delete_warning}
                    </p>
                    <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{mexDeletePermanently}</strong></p>
                        <input
                            className="delete_input"
                            placeholder={` ${mexDeletePermanently}`}
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="modal_footer">
                    <div className="footer_btn_cont">

                        <button
                            className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                            onClick={actionOrganization}
                            disabled={isButtonDisabled}
                        >
                            {loadingDel ? (
                                <Spinner loading={loadingDel} />
                            ) : (
                                <>{t.delete}</>
                            )}
                        </button>
                        <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                    </div>
                </div>
            </Modal>
        )
    } else {
        modalContent = (
            <Modal show={show} onHide={handleCloseModal} className="modal_delete">
                <div className="modal_header">
                    <p>{t.cloud.delete_file}</p>
                    <i className="fa-solid fa-x" onClick={handleCloseModal}></i>
                </div>
                <div className="modal_body">
                    <p className="warning_delete_message">
                        {t.cloud.delete_temp_warning}
                    </p>
                    <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{mexDelete}</strong></p>
                        <input
                            className="delete_input"
                            placeholder={` ${mexDelete}`}
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className="modal_footer">
                    <div className="footer_btn_cont">
                        <button
                            className={`delete_btn ${isButtonDisabled ? "" : "delete_btn_active"}`}
                            onClick={actionOrganization}
                            disabled={isButtonDisabled}
                        >
                            {loadingDel ? (
                                <Spinner loading={loadingDel} />
                            ) : (
                                <>{t.delete}</>
                            )}
                        </button>
                        <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                    </div>
                </div>
            </Modal>
        )
    }

    return modalContent || null
};

export default ActionFileModal;
